enum ChannelType {
  NONE = 0,
  EMAIL = 1,
  SMS = 2,
}

export default ChannelType
